import {Component, Injector} from "@angular/core";
import {AbstractSelectSearchControlComponent} from "./abstract-select-search-control.component";
import {registerSearchControl} from "../abstract-search-control.component";

/**
 * Provides a multiple selection on a search form. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-multi-select-search-control",
    templateUrl: "./multi-select-search-control.component.html",
    providers: [
        registerSearchControl(MultiSelectSearchControlComponent)
    ]
})
export class MultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
    }
}
